import { app } from '../../../app';

app.factory('SmsUserOtp', SmsUserOtp);

/** @ngInject */
function SmsUserOtp($resource) {
    return $resource('app/rest/smsGenerateOtp/:id', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-otp/sms-user-otp.service.js